// Page MailTemplate

import React from 'react'
import async from 'async'
import _ from 'lodash'

import app from '../../../app.jsx'
import MailTemplateForm from '../../mailtemplate/mailtemplate_form/mailtemplate_form.jsx'
import MailtemplateUtil from '../../../lib/mailtemplateutil.jsx'
import BaseSettings from '../../page/base_setting/base_setting.jsx'

class PageMailTemplate extends BaseSettings {
  constructor (props) {
    super(props, 'setting-mailtemplate', 'setting-user', 'setting-mailtemplate')

    this.data = {
      loading: true,
      mailTemplate: {
        id: null,
        en: [],
        nl: [],
        de: [],
        us: []
      },
      defaultMailTemplate: {
        en: [],
        nl: [],
        de: [],
        us: []
      }
    }

    this.state = {
      isLoading: true,
      dataDate: new Date()
    }

    this._references = {
      pageHeader: React.createRef()
    }

    this._bUnMounted = false
  }

  componentWillUnmount () {
    this._bUnMounted = true
  }

  renderContent () {
    return (
      <MailTemplateForm
        mailTemplate={this.data.mailTemplate}
        country={app.teamCountry}
        isQuickbookConnected={app.isQuickbookConnected()}
        defaultTemplate={this.data.defaultMailTemplate}
        onSubmit={this._onSubmit.bind(this)}
      />
    )
  }

  componentDidMount () {
    this._getData()
  }

  getContentClassname () {
    return 'alt'
  }

  /* Event Handlers */
  _onChangePage (pageIdent) {
    app.changePage(pageIdent)
  }

  _onSubmit () {
    this._saveMailTemplate(err => {
      if (err) {
        this._onError()
      } else {
        this._reloadData()

        if (this._references.pageHeader.current) {
          this._references.pageHeader.current.showSuccess(
            'setting.pdfTemplate.msgSuccessTitle',
            'setting.pdfTemplate.msgSuccessContent'
          )
        }
      }
    })
  }

  /* Private Functions */
  _saveMailTemplate (callback) {
    const data = MailtemplateUtil.getSaveObject(this.data.mailTemplate)

    if (this.data.mailTemplate.id) {
      app
        .service('/api/team/mailtemplate')
        .patch(this.data.mailTemplate.id, data)
        .then(_updateRes => {
          callback(null)
        })
        .catch(updateErr => {
          app.debug('PageMailTemplate: _onSubmit _saveMailTemplate', updateErr)
          callback(updateErr)
        })
    } else {
      app
        .service('/api/team/mailtemplate')
        .create(data)
        .then(_result => {
          callback(null)
        })
        .catch(err => {
          app.debug('PageMailTemplate: _saveMailTemplate err', err)
          callback(err)
        })
    }
  }

  _reloadData () {
    this._getData()
  }

  _onError () {
    if (this._references.pageHeader.current) {
      this._references.pageHeader.current.showError(
        'setting.pdfTemplate.msgErrorTitle',
        'setting.pdfTemplate.msgErrorInfo'
      )
    }
  }

  _getData () {
    this.data.loading = true

    async.series(
      [
        done => {
          this._getPageData(done)
        },
        done => {
          this._getDataMailTemplate(done)
        },
        done => {
          this._getDataDefaultMailTemplate(done)
        }
      ],
      (err, _res) => {
        this._onDataReceived(err)
      }
    )
  }

  _getDataMailTemplate (callback) {
    app.debug('PageMailTemplate: _getDataMailTemplates [start]')
    app
      .service('/api/team/mailtemplate')
      .find()
      .then(result => {
        if (result && result && result.data.length > 0) {
          this.data.mailTemplate = MailtemplateUtil.getRenderObject(
            result.data[0]
          )
        }
        callback(null)
      })
      .catch(err => {
        callback(err)
      })
  }

  _getDataDefaultMailTemplate (callback) {
    app.debug('PageMailTemplate: _getDataMailTemplatesDefault [start]')
    app
      .service('/api/team/mailtemplatedefault')
      .find()
      .then(result => {
        if (result && result.data.length > 0) {
          this.data.defaultMailTemplate = MailtemplateUtil.getRenderObject(
            result.data[0]
          )
        }
        callback(null)
      })
      .catch(err => {
        app.debug('PageMailTemplate: _getDataDefaultMailTemplate Error', err)
        callback(err)
      })
  }

  _onDataReceived (err) {
    if (this._bUnMounted) return

    if (err) {
      app.debug('PageMailTemplate: _onDataReceived Error', err)
    } else {
      app.debug('PageMailTemplate: _onDataReceived [done]')
    }
    this.setState({ isLoading: !!err, dataDate: new Date() })
  }

  _getTemplateSaveObject (lang) {
    const templates = []
    this.data.mailTemplate[lang].map(template => {
      if (!template.bDefault) {
        const newObj = _.cloneDeep(template)
        delete newObj.bDefault

        templates.push(newObj)
      }
    })

    return templates
  }
}

export default PageMailTemplate
